import { render, staticRenderFns } from "./ConnectorDetail.vue?vue&type=template&id=16064f7f&"
import script from "./ConnectorDetail.vue?vue&type=script&lang=js&"
export * from "./ConnectorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports